// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

export const VerifiedBuyer = (props: IconProps) => (
  <svg viewBox="0 0 500 500" {...props}>
    <circle fill="#8CC541" cx="250.9" cy="250" r="250" />
    <path
      fill="#FFF"
      d="M264.2 101.9h-23.6c-3.7 0-6.7 3-6.7 6.7v29.2c-35.1 7.1-57.4 30.7-57.4 61.1 0 16.3 6.3 29.7 19.1 40.9 10.5 9.1 25.7 17.1 48 25 27.4 10.1 38.5 20.1 38.5 34.7 0 7.5-3.4 14.1-9.8 18.9-7 5.3-17.2 8.2-28.7 8.2-18 0-36.7-5-51.3-13.9-1.1-.6-2.3-1-3.5-1-.7 0-1.4.1-2.1.4-1.9.6-3.4 2-4.1 3.9l-9.1 23.1c-1.2 3-.1 6.3 2.6 8.1 13.3 8.6 34.3 14.6 55.1 16v28.4c0 3.7 3 6.7 6.7 6.7h23.9c3.7 0 6.7-3 6.7-6.7v-30.2c17.5-3.6 32.2-11.2 42.8-22.2 11.1-11.5 17.2-26.4 17.2-41.9 0-16.9-5.5-30.7-16.7-42.3-10.2-10.5-25-19.1-46.6-27.1-17.6-6.6-27.8-11.5-34.1-16.6-6.1-4.8-8.6-9.6-8.6-16.5 0-10.6 8.8-23 33.6-23 23.6 0 38.5 7.7 44.8 11 1 .5 2 .7 3.1.7.8 0 1.5-.1 2.3-.4 1.8-.6 3.2-2 3.9-3.7l9.5-22.7c1.3-3.2 0-6.9-3-8.5-13.5-7.2-28.5-11.3-45.9-12.5v-27.1c0-3.7-2.9-6.7-6.6-6.7z"
    />
  </svg>
);

export const VerifiedReviewer = (props: IconProps) => (
  <svg viewBox="0 0 500 500" {...props}>
    <title>Verified Reviewer</title>
    <circle fill="#75C6B8" cx="250" cy="250" r="250" />
    <path
      fill="#FFF"
      d="M395.1 166.5L368.7 140c-3.6-3.6-8-5.4-13.2-5.4-5.2 0-9.6 1.8-13.2 5.4L214.8 267.7l-57.1-57.3c-3.6-3.6-8-5.4-13.2-5.4-5.2 0-9.6 1.8-13.2 5.4l-26.4 26.4c-3.6 3.6-5.4 8-5.4 13.2 0 5.2 1.8 9.6 5.4 13.2l70.3 70.3 26.4 26.4c3.6 3.6 8 5.4 13.2 5.4 5.2 0 9.6-1.8 13.2-5.4l26.4-26.4L395 192.9c3.6-3.6 5.4-8 5.4-13.2.2-5.2-1.7-9.6-5.3-13.2z"
    />
  </svg>
);

export const StaffReviewer = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
    <title>Staff Reviewer</title>
    <circle fill="#FAB718" cx="250" cy="250" r="250" />
    <path
      fill="#FFF"
      d="M204 293.6c1.4 10.2 4.3 17.7 8.5 22.8 7.7 9.1 20.9 13.7 39.6 13.7 11.2 0 20.3-1.2 27.3-3.6 13.2-4.6 19.9-13.2 19.9-25.8 0-7.3-3.2-13-9.7-17-6.5-3.9-16.8-7.4-30.9-10.4l-24.1-5.3c-23.7-5.2-39.9-10.9-48.7-17-15-10.3-22.5-26.3-22.5-48.1 0-19.9 7.3-36.4 22-49.6 14.7-13.2 36.2-19.8 64.6-19.8 23.7 0 43.9 6.2 60.7 18.6 16.7 12.4 25.5 30.4 26.3 54.1h-44.6c-.8-13.4-6.8-22.9-17.9-28.5-7.4-3.7-16.6-5.6-27.7-5.6-12.3 0-22.1 2.4-29.4 7.2-7.3 4.8-11 11.6-11 20.2 0 7.9 3.6 13.9 10.8 17.8 4.6 2.6 14.5 5.7 29.5 9.2l39 9.2c17.1 4 29.9 9.4 38.4 16.1 13.2 10.5 19.9 25.6 19.9 45.4 0 20.3-7.9 37.2-23.5 50.6-15.7 13.4-37.9 20.1-66.5 20.1-29.3 0-52.3-6.6-69-19.8-16.8-13.2-25.1-31.4-25.1-54.5H204z"
    />
  </svg>
);

export const ExpertReviewer = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
    <title>Expert Reviewer</title>
    <circle fill="#54C7E6" cx="250" cy="250" r="250" />
    <path
      fill="#FFF"
      d="M334.9 179.3H217.3v47.2h108v38.6h-108v57.2h123.1v40H171.9V140h163v39.3z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Badges.js